import React from "react";
import Box from "@mui/material/Box";
import LoadingImage from '../../assets/images/loading-animation.gif'

// Most call sites render this from inside a routed page, so it should stay contained to
// that page's content area by default — only the app-boot gates (App.js, index.js,
// DefaultLayout's pre-bootstrap overlay) need fullScreen to actually block the whole viewport.
const Loading = ({ zIndex = 9999, fullScreen = false }) => {
  const styles = {
    // fullScreen covers the whole viewport (position: fixed); otherwise it fills its
    // nearest positioned ancestor only, so it doesn't hide chrome like the header/sidebar.
    position: fullScreen ? "fixed" : "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(1, 1, 1, 0.5)",
    zIndex: zIndex,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <Box sx={styles}>
      {/* <CircularProgress /> */}
      <img src={LoadingImage} width={200} />
      

    </Box>
  );
};

export default Loading;
